import { css } from 'omni-ui';
export default css `
  :host strong {
    color: inherit;
  }

  /* Parent container needs have a height set */
    :host,
  omni-style.omni,
  .wysiwyg {
    height: 100%;
    width: 100%;
  }

  .wysiwyg {
    display: flex;
    flex-flow: column nowrap;
    position: relative;
  }
  .wysiwyg.skeleton {
    /* maintain a similar height to an empty state */
      height: 7rem;
  }

  .ProseMirror {
    word-break: break-word;
  }

  .is-editing .ProseMirror p.is-editor-empty:first-child::before {
    color: var(--color-shark);
    content: attr(data-placeholder);
    float: left;
    height: 0;
    pointer-events: none;
  }

  .is-editing .ProseMirror {
    height: 100%;
    border-radius: 0 0 0.43rem 0.43rem;
    border: solid thin var(--color-pale-grey-three);
    background-color: var(--color-pale-grey-two);
    padding: 1.07rem 1.43rem;
    overflow-y: scroll;
    white-space: pre-wrap;
  }

  .is-editing .ProseMirror:focus-visible {
    outline: solid thin var(--color-primary);
  }

  div.menu-container {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    gap: 0.57rem;
    padding: 0.36rem 0.71rem;
    border: solid thin var(--color-pale-grey-three);
    border-bottom: none;
    border-radius: 0.43rem 0.43rem 0 0;
    background-color: var(--color-white);
  }
  .menu-container button.button {
    width: 2.14rem;
    height: 2.14rem;
    padding: 0;
    border-radius: 0.29rem;
    align-content: center;
    background-color: var(--color-white);
    border: none;
  }

  omni-icon::part(icon) {
    width: 1.07rem;
    margin: 0 auto;
  }

  :host([overflowed]) {
    -webkit-mask-image: linear-gradient(
      180deg,
      var(--black) 60%,
      transparent
    );
    mask-image: linear-gradient(180deg, var(--black) 60%, transparent);
  }

  .omni ul {
    list-style: disc;
  }

  .omni ul,
  .omni ol {
    padding-left: 1.29rem;
  }

  .mentionList {
    position: absolute;
    top: var(--mention-list-y);
    left: var(--mention-list-x);
    overflow-y: auto;
    max-height: 200px;
    z-index: 2;
  }
  .omni .mention {
    font-weight: bold;
  }
  .omni .mention-item-selected {
    background-color: var(--color-whitesmoke);
    color: var(--color-gray-0a);
  }
  .omni .dropdown-content {
    padding: 0;
  }

  omni-loading-indicator {
    position: absolute;
    left: var(--loader-x);
    /* center it - 3px is 1/2 of the arbitray extra size */
      top: calc(var(--loader-y) - 3px);
    z-index: 2;
    background-color: var(--color-pale-grey-two);
    box-shadow: 0 0 0.25rem 0.125rem var(--color-pale-grey-two);
    border-radius: 50%;
  }

  omni-loading-indicator,
  omni-loading-indicator::part(svg) {
    width: var(--loader-size);
    height: var(--loader-size);
  }
`;
//# sourceMappingURL=omni-wysiwyg.css.js.map